function inquiryFormLabels() {
	const blocks = document.querySelectorAll(".inquiry-form");
	if (blocks.length < 1) return;

	blocks.forEach(block => {
		const fields = block.querySelectorAll(".gfield");
		if (fields.length < 1) return;

		fields.forEach(field => {
			const label = field.querySelector(".gfield_label");
			const input = field.querySelector("input, textarea, select");
			if (!label || !input || input.type === "hidden") return;

			function updateLabelState() {
				const isActive = document.activeElement === input;
				const hasValue = input.value !== "";

				field.classList.toggle("is-active", isActive);
				field.classList.toggle("has-value", hasValue);
				label.classList.toggle("is-active", isActive);
				label.classList.toggle("has-value", hasValue);
			}

			updateLabelState();

			input.addEventListener("focus", updateLabelState);
			input.addEventListener("blur", updateLabelState);
			input.addEventListener("input", updateLabelState);
			input.addEventListener("change", updateLabelState);
		});
	});
}

function disableInquiryFormSelectPlaceholders() {
	const selects = document.querySelectorAll(".inquiry-form .gform_wrapper select");
	if (selects.length < 1) return;

	selects.forEach(select => {
		const firstOption = select.options[0];
		if (!firstOption) return;

		const isBlankOption = firstOption.value.trim() === "" && firstOption.textContent.trim() === "";

		if (isBlankOption) {
			firstOption.disabled = true;
		}
	});
}

function toggleInquiryFormSubmit() {
	const forms = document.querySelectorAll(".inquiry-form form");
	if (forms.length < 1) return;

	forms.forEach(form => {
		const submit = form.querySelector('input[type="submit"], button[type="submit"]');
		const requiredFields = form.querySelectorAll(".gfield_contains_required");
		if (!submit || requiredFields.length < 1) return;

		if (form.inquiryUpdateSubmitState) {
			form.inquiryUpdateSubmitState();
			return;
		}

		function fieldHasValue(field) {
			if (field.hidden || field.getAttribute("aria-hidden") === "true" || field.style.display === "none") {
				return true;
			}

			const inputs = Array.from(field.querySelectorAll("input, textarea, select")).filter(input => {
				return input.type !== "hidden" && !input.disabled;
			});

			const checkableInputs = inputs.filter(input => input.type === "radio" || input.type === "checkbox");
			if (checkableInputs.length) {
				return checkableInputs.some(input => input.checked);
			}

			return inputs.some(input => input.value.trim() !== "");
		}

		function updateSubmitState() {
			submit.disabled = !Array.from(requiredFields).every(fieldHasValue);
		}

		updateSubmitState();

		form.addEventListener("input", updateSubmitState);
		form.addEventListener("change", updateSubmitState);
		form.inquiryUpdateSubmitState = updateSubmitState;
	});
}

function initInquiryForm() {
	inquiryFormLabels();
	disableInquiryFormSelectPlaceholders();
	toggleInquiryFormSubmit();
}

document.addEventListener("DOMContentLoaded", initInquiryForm);
window.addEventListener("load", initInquiryForm);
window.setTimeout(initInquiryForm, 250);
document.addEventListener("gform/post_init", initInquiryForm);
document.addEventListener("gform_post_render", initInquiryForm);
document.addEventListener("gform/ajax/post_ajax_submission", initInquiryForm);
